import { UserFeatureResponseModel } from "api/merchantRepository/features/model/UserFeatureResponseModel";
import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { BasePermissionMenu } from "app/based/baseApiModel/basePermissionMenu/BasePermissionMenu";
import { BasePermissionCapability } from "app/based/baseApiModel/basePermissionMenu/BasePermissionCapability";
import { SidebarMenuConfigModel } from "components/sidebar/data/models/SidebarMenuConfigModel";
import { LoginResponseModel } from "features/login/data/model/responseModel/LoginResponseModel";

export class AppStartUpResponseEntity {
  user?: LoginResponseModel;
  userFeature?: UserFeatureResponseModel[];
  userMenu?: BasePermissionMenu[];
  menuConfig?: SidebarMenuConfigModel;
  capabilities?: BasePermissionCapability[];
  serviceOptions?: BaseFilterListResponseModel[];

  constructor(data?: Partial<AppStartUpResponseEntity>) {
    this.user = data?.user;
    this.userFeature = data?.userFeature;
    this.userMenu = data?.userMenu;
    this.menuConfig = data?.menuConfig;
    this.capabilities = data?.capabilities;
    this.serviceOptions = data?.serviceOptions;
  }
}
